import { InvoiceID, InvoiceNanoID, InvoiceUUID } from './invoicesTypes';

const baseUrl = 'invoices';

export class InvoiceBffUrl {
  static index() {
    return baseUrl;
  }

  static create() {
    return baseUrl;
  }

  static createFromProforma() {
    return `${baseUrl}/create_from_proforma`;
  }

  static createFromProformaAsync() {
    return `${baseUrl}/create_from_proforma_async`;
  }

  static pay(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay`;
  }

  static payAsync(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay_async`;
  }

  static void(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/void`;
  }

  static batchVoid() {
    return `${baseUrl}/void_invoices_async`;
  }

  static chargeback(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/chargeback`;
  }

  static cancel(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/cancel`;
  }

  static cancelSmartContracts(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/cancel_smart_contracts`;
  }

  static cancelSmartContractsAsync(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/cancel_smart_contracts_async`;
  }

  static uncollectible(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/uncollectible`;
  }

  static send(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/send`;
  }

  static show(invoiceUuid: InvoiceUUID | InvoiceNanoID | InvoiceID) {
    return `${baseUrl}/${invoiceUuid}`;
  }

  static payFromDeposit(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay_from_deposit`;
  }

  static payFromDepositAsync(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay_from_deposit_async`;
  }

  static batchPayFromDepositAsync() {
    return `${baseUrl}/pay_invoices_from_deposit_async`;
  }

  static download(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/download`;
  }

  static downloadPdf(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/download_pdf`;
  }

  static receipt(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/receipt`;
  }

  static receiptPdf(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/receipt_pdf`;
  }

  static sendToEmail(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/send_to_email`;
  }

  static contractorAllocate(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/contractor_allocate`;
  }

  static contractorPayBde(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/contractor_pay_bde`;
  }

  static changeCurrency(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/change_currency`;
  }

  static payInternal(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay_internal`;
  }

  static payInternalAsync(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/pay_internal_async`;
  }

  static updateBillingInfo(invoiceId: InvoiceID) {
    return `${baseUrl}/${invoiceId}/update_billing_info`;
  }

  static cacheSync(invoiceSlug: string) {
    return `${baseUrl}/${invoiceSlug}/cache_sync`;
  }
}
